export default "__VITE_ASSET__Dwrgrigx__"